import React, { useCallback, useEffect, useMemo, useState, useContext } from "react";
import PostureMetrics from "./Metrics";
import "./Metrics.css";
import postureMetricsConfig from './posture-metrics-config.json'
import { RootContext } from "../../../../contexts/root-context";
function MetricsContainer() {
  const initialMetricsData = useMemo(() => ({
    plantSecurityScore: [{ metricName: postureMetricsConfig.plantSecurityScore.metricName, metricScore: postureMetricsConfig.plantSecurityScore.defaultScore, metricStat: "" }],
    criticalIssues: [{ metricName: postureMetricsConfig.criticalIssues.metricName, metricScore: postureMetricsConfig.criticalIssues.defaultScore, metricStat: "" }],
    highIssues: [{ metricName: postureMetricsConfig.highIssues.metricName, metricScore: postureMetricsConfig.highIssues.defaultScore, metricStat: "" }],
    mediumIssues: [{ metricName: postureMetricsConfig.mediumIssues.metricName, metricScore: postureMetricsConfig.mediumIssues.defaultScore, metricStat: "" }],
    lowIssues: [{ metricName: postureMetricsConfig.lowIssues.metricName, metricScore: postureMetricsConfig.lowIssues.defaultScore, metricStat: "" }],
    totalDevices: [{ metricName: postureMetricsConfig.totalDevices.metricName, metricScore: postureMetricsConfig.totalDevices.defaultScore, metricStat: "" }],
  }), []);

  const [actualMetrics, setActualMetrics] = useState(initialMetricsData);
  console.log('acutual ,metrics data', actualMetrics)
  const { deviceData } = useContext(RootContext);
  const { PlantIdData } = useContext(RootContext)
  console.log("plantIdData", PlantIdData)
  const fetchMetricsData = useCallback(async () => {
    try {



      const data = PlantIdData;
      console.log('API Data', data);
      const allDevices = deviceData?.data || [];
      const totalDevicesCount = allDevices.length;
      console.log('postu metrics', allDevices)
      const updatedMetrics = {
        plantSecurityScore: [{
          metricName: postureMetricsConfig.plantSecurityScore.metricName,
          metricScore: data[postureMetricsConfig.plantSecurityScore.metricScore]?.value || "0",
          metricStat: data[postureMetricsConfig.plantSecurityScore.metricScore]?.unit || postureMetricsConfig.plantSecurityScore.defaultStat,
        }],
        criticalIssues: [{
          metricName: postureMetricsConfig.criticalIssues.metricName,
          metricScore: data[postureMetricsConfig.criticalIssues.metricScore]?.value || "0",
          metricStat: data[postureMetricsConfig.criticalIssues.metricScore]?.unit || " ",
        }],
        highIssues: [{
          metricName: postureMetricsConfig.highIssues.metricName,
          metricScore: data[postureMetricsConfig.highIssues.metricScore]?.value || "0",
          metricStat: data[postureMetricsConfig.highIssues.metricScore]?.unit || " ",
        }],
        mediumIssues: [{
          metricName: postureMetricsConfig.mediumIssues.metricName,
          metricScore: data[postureMetricsConfig.mediumIssues.metricScore]?.value || "0",
          metricStat: data[postureMetricsConfig.mediumIssues.metricScore]?.unit || " ",
        }],
        lowIssues: [{
          metricName: postureMetricsConfig.lowIssues.metricName,
          metricScore: data[postureMetricsConfig.lowIssues.metricScore]?.value || "0",
          metricStat: data[postureMetricsConfig.lowIssues.metricScore]?.unit || " ",
        }],
        totalDevices: [{
          metricName: postureMetricsConfig.totalDevices.metricName,
          metricScore: totalDevicesCount.toString(),
          metricStat: postureMetricsConfig.totalDevices.defaultStat,
        }],
      };

      setActualMetrics(updatedMetrics);
    } catch (error) {
      console.error("Error fetching the metrics data:", error);
    }
  }, [initialMetricsData, deviceData, PlantIdData]);

  useEffect(() => {
    fetchMetricsData();
  }, [fetchMetricsData]);



  const metricComponents = useMemo(() => {
    return Object.entries(actualMetrics)
      .filter(([key]) => postureMetricsConfig[key]?.isEnabled)
      .map(([key, legends],index) => (
        <div key={key} 
      
         className="col-sm-6 col-md-4 col-lg-4 col-xl-2 cybershield-posture-metrics"
          style={{ paddingLeft: "0px", marginLeft: index === 0 ? "24px" : "-8px" }}
        
        >
          <PostureMetrics position={3} legends={legends} />
        </div>
      ));
  }, [actualMetrics]);


  return (
    <div className="posture-metrics-container-row" style={{ zIndex: "-1" }}>
      {metricComponents}
    </div>
  );
}

export default MetricsContainer;
